import React from 'react';

interface MatikIconProps {
  height?: number;
  className?: string;
}

export const MatikLogo: React.FC<MatikIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 43 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.02446 15.7464C7.82272 9.02542 14.721 5.0369 21.4322 6.83778C23.7498 7.45968 25.742 8.69066 27.2832 10.3127L32.221 7.45768C29.8958 4.61703 26.6925 2.45237 22.8794 1.42917C13.1854 -1.1721 3.22119 4.58909 0.623695 14.2971C-1.9738 24.0052 3.77904 33.9839 13.473 36.5851C22.7127 39.0645 32.1978 33.9468 35.3157 25.0556L29.892 23.6002C27.5923 29.5046 21.175 32.8549 14.9201 31.1765C8.20893 29.3757 4.2262 22.4673 6.02446 15.7464Z"
        fill="#20DFAC"
      />
      <path
        d="M35.5608 13.5275L42.4796 25.5287L37.2973 24.1381C36.5811 23.9459 35.9705 23.4767 35.5997 22.8336L33.8724 19.8375L30.8807 21.5673C30.2386 21.9386 29.4755 22.0392 28.7593 21.847L23.5769 20.4564L35.5608 13.5275Z"
        fill="#20DFAC"
      />
    </svg>
  );
};
